module.exports = __webpack_public_path__ + "static/media/background.223f9c5e.jpg";